import { Preferences } from "@capacitor/preferences";

const getNotificationStatus = async (taskId, notificationType) => {
  try {
    const { value } = await Preferences.get({
      key: `task_${taskId}_notifications_${notificationType}`,
    });
    return value ? JSON.parse(value) : null;
  } catch (error) {
    // Handle chunk loading errors when offline
    console.warn("Failed to get notification status:", error.message);
    return null;
  }
};

export default getNotificationStatus;
